// src/providers/pages-progress-provider.tsx
import React2 from "react";

// src/components/pages-progress.tsx
import { useEffect } from "react";
import { isSameURL, isSameURLWithoutSearch } from "@bprogress/core";
import { useProgress, withMemo } from "@bprogress/react";
import Router from "next/router.js";
var PagesProgressComponent = ({
  shallowRouting = false,
  disableSameURL = true,
  startPosition = 0,
  delay = 0,
  stopDelay = 0
}) => {
  const { start, stop } = useProgress();
  useEffect(() => {
    const handleRouteStart = (url) => {
      const targetUrl = new URL(url, location.href);
      const currentUrl = new URL(location.href);
      if (shallowRouting && isSameURLWithoutSearch(targetUrl, currentUrl) && disableSameURL)
        return;
      if (isSameURL(targetUrl, currentUrl) && disableSameURL) return;
      start(startPosition, delay);
    };
    const handleRouteDone = () => stop(stopDelay);
    Router.events.on("routeChangeStart", handleRouteStart);
    Router.events.on("routeChangeComplete", handleRouteDone);
    Router.events.on("routeChangeError", handleRouteDone);
    return () => {
      Router.events.off("routeChangeStart", handleRouteStart);
      Router.events.off("routeChangeComplete", handleRouteDone);
      Router.events.off("routeChangeError", handleRouteDone);
    };
  }, []);
  return null;
};
var PagesProgress = withMemo(PagesProgressComponent);
PagesProgress.displayName = "PagesProgress";

// src/providers/next-progress-provider.tsx
import React from "react";
import {
  ProgressProvider
} from "@bprogress/react";
var NextProgressProvider = ({
  children,
  ProgressComponent,
  color,
  height,
  options,
  spinnerPosition,
  style,
  disableStyle,
  nonce,
  stopDelay,
  delay,
  startPosition,
  disableSameURL,
  shallowRouting,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    ProgressProvider,
    {
      color,
      height,
      options,
      spinnerPosition,
      style,
      disableStyle,
      nonce,
      stopDelay,
      delay,
      startPosition,
      disableSameURL,
      shallowRouting
    },
    /* @__PURE__ */ React.createElement(
      ProgressComponent,
      {
        stopDelay,
        delay,
        startPosition,
        disableSameURL,
        shallowRouting,
        ...props
      }
    ),
    children
  );
};

// src/providers/pages-progress-provider.tsx
var PagesProgressProvider = ({
  children,
  ...props
}) => {
  return /* @__PURE__ */ React2.createElement(NextProgressProvider, { ProgressComponent: PagesProgress, ...props }, children);
};
export {
  PagesProgressProvider as ProgressProvider
};
